import * as React from 'react';
import { MediaContainerFieldsFragment } from 'types/generated';
import { ImageWithFocalPoint } from '../ImageWithFocalPoint';
import clsx from 'clsx';

type Props = {
  data: MediaContainerFieldsFragment;
};

const MediaContainer = ({ data }: Props) => {
  const collection = data.mediasCollection;

  return (
    <div className={`gid-flow-row md:grid-flow-column gap-16`}>
      {collection?.items &&
        collection.items.map(function (object) {
          {
            if (object?.__typename === 'ImageWithFocalPoint') {
              return (
                <div
                  className={`relative h-[330px] ${clsx({
                    'col-span-full md:col-span-4': collection.items.length === 3,
                    'col-span-6': collection.items.length === 2,
                    'col-span-full': collection.items.length === 1,
                  })}`}
                >
                  <ImageWithFocalPoint image={object} sectionId={object.id} className={'rounded-28'} priority={false} />
                </div>
              );
            } else return;
          }
        })}
    </div>
  );
};
export default MediaContainer;
